import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';
import { allFilterPages } from '@features/filter/static/filterUtil';

import { fetchBrandList } from '@store/actions/BrandAction';

import { replaceUnderLine } from '@utils/Util';

const Brand = ({ isDependentFilter, filterPageName }) => {
	const [brands, setBrands] = useState([]);
	const [brandList, setBrandList] = useState([]);
	const brandsData = useSelector((store) => store.brandStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const dispatch = useDispatch();
	useEffect(() => {
		if (!isDependentFilter) {
			setBrands(brandList);
		}
	}, [brandsData]);

	useEffect(() => {
		if (brandList?.length === 0 && !isDependentFilter) {
			dispatch(fetchBrandList());
		} else {
			onSetBrandData();
		}
	}, [dependentFilterList]);

	const filterData = {
		[allFilterPages.MY_PROJECTS]: dependentFilterList?.projectBrandList
	};

	const onSetBrandData = async () => {
		let dependentFilterData =
			filterPageName in filterData
				? filterData[filterPageName]?.map((item) => ({
						...item,
						id: item?.id,
						name: replaceUnderLine(item?.name)
					}))
				: dependentFilterList?.brandList;
		let responseData = isDependentFilter
			? dependentFilterData
			: brandsData?.map((item) => {
					return { id: item.id, name: item.name };
				});
		setBrandList(responseData);
		setBrands(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? brandList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: brandList;
		setBrands(searchResult);
	};
	return (
		<>
			<FilterName type="BRAND" />
			<Checkbox type="BRAND" data={brands} handleSearch={handleSearch} />
		</>
	);
};

export default Brand;
